export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto text-center">
        <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
          关于我们
        </span>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-6">
          天天影视 · 综艺爱好者的在线家园
        </h2>
        <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-4 max-w-[700px] mx-auto">
          <p>
            天天影视是一个专注于综艺节目在线观看的平台，汇集了当下最热门的真人秀、搞笑脱口秀、音乐综艺和娱乐视频内容。自上线以来，我们始终坚持<strong className="text-foreground-800">高清免费、天天更新</strong>的原则，为全国综艺爱好者提供优质的在线观看体验。
          </p>
          <p>
            我们的团队热爱综艺文化，深知每一个精彩瞬间都值得被看见。无论是让你开怀大笑的脱口秀段子，还是让人感动落泪的真人秀故事，天天影视都致力于将它们完整、高清地呈现给你。
          </p>
          <p>
            从经典老牌综艺到最新热门节目，从户外真人秀到慢生活治愈系——天天影视的综艺库持续丰富，每天都有新内容上线。我们相信，好的综艺节目能带来快乐、启发和共鸣，而这份美好应该让每个人都能轻松获取。
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-8 pt-8 border-t border-background-200/70">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-extrabold text-primary-500">24h</div>
            <div className="text-xs text-foreground-500 mt-1">全天更新</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-extrabold text-primary-500">1000+</div>
            <div className="text-xs text-foreground-500 mt-1">综艺节目</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-extrabold text-primary-500">全免费</div>
            <div className="text-xs text-foreground-500 mt-1">无需会员</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-extrabold text-primary-500">高清</div>
            <div className="text-xs text-foreground-500 mt-1">流畅播放</div>
          </div>
        </div>
      </div>
    </section>
  );
}